import * as React from "react";
import { RightsCtx } from "../context/RightsContext";

const useRights = () => React.useContext(RightsCtx);

export default useRights;
